module.exports = __webpack_public_path__ + "img/SW.57431cf5.webp";